import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dropdownLabel: {
		id: 'native-issue-table.common.issue-create-form.context-fields.issue-type-dropdown.dropdown-label',
		defaultMessage: 'Issue type',
		description: 'Accessible label to be set on the issue type dropdown element',
	},
});
